export default "__VITE_ASSET__Ck4yg1NZ__"